import { render, staticRenderFns } from "./ContentPreviewProductMark.vue?vue&type=template&id=f8f682c0&scoped=true&"
import script from "./ContentPreviewProductMark.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewProductMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f682c0",
  null
  
)

export default component.exports